import { createStyles } from 'antd-style';

import {
  heightExtendingError,
  partnerAccessTopBar,
  shipmentPageInnerContentNoMargin,
} from '../styles/mixins';

export const useNewShipmentPageStyles = createStyles(
  ({ token }, { innerContent } = {}) => ({
    newShipmentPageWrapper: {
      '&&': {
        ...heightExtendingError(token),
        ...shipmentPageInnerContentNoMargin(token, innerContent),
      },
    },
    partnerAccessTopBar: partnerAccessTopBar(token),
  })
);
